import { memo, FC } from 'react'
import { isEqual } from 'lodash'
import { Session } from 'src/app/types'
import SessionParticipants from './SessionParticipants'

type ParticipantSessionBodyProps = Session

const ParticipantSessionBody: FC<ParticipantSessionBodyProps> = ({
  participants,
  name,
}: Session) => {
  return (
    <div className="px-4 pt-4 relative w-full h-mainView overflow-scroll scrollbar-hide">
      <h1 className="mb-4 font-bold text-base">{name}</h1>
      {<SessionParticipants isHost={false} participants={participants} />}
    </div>
  )
}

// Only update/ rerender ParticipantSession if session data has changed
const ParticipantSessionBodyMemo = memo(
  ParticipantSessionBody,
  (prevSession, nextSession) => isEqual(prevSession, nextSession)
)

export default ParticipantSessionBodyMemo
